
import logo from '../assets/logo.png';
import man from '../assets/man.png';
import circle from '../assets/circle.svg';
import flutter from '../assets/flutter.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import js from '../assets/js.png';
import react from '../assets/react.png';
import css from '../assets/css.png';
import dan1 from '../assets/dan1.png';
import dan2 from '../assets/dan2.png';
import dan3 from '../assets/dan3.png';

export default {
  logo,
  man,
  circle,
  flutter,
  redux,
  sass,
  js,
  react,
  css,
  dan1,
  dan2,
  dan3
};
